import { request } from '@@/plugin-request';

export async function get4Table(params) {
  return request('/api/coursematch/get4Table', {
    method: 'GET',
    params,
  });
}

export async function getMatchmakers(params) {
  return request('/api/coursematch/getMatchmakers', {
    method: 'GET',
    params,
  });
}

export async function update(body) {
  return request('/api/coursematch/update', {
    method: 'PUT',
    data: body,
  });
}

export async function getCountries(params) {
  return request('/api/school/country', {
    method: 'GET',
    params,
  });
}

export async function getCourseLesson4Student(params) {
  return request('/api/coursematch/student', {
    method: 'GET',
    params,
  });
}
export async function getByLesson(params) {
  return request('/api/coursematch/lesson', {
    method: 'GET',
    params,
  });
}

// export async function getMatchmakerNotesById(params) {
//   return request('/api/coursematch/getMatchmakerNotesById', {
//     method: 'GET',
//     params,
//   });
// }

export async function getRecruimentNeedsMatches(params) {
  return request('/api/coursematch/getRecruimentNeedsMatches', {
    method: 'GET',
    params,
  });
}

// export async function createRecuitmentTasks(payload) {
//   return request('hr/api/recruitmentTasks', {
//     method: 'POST',
//     data: payload,
//   });
// }
export async function createRecuitmentTasks(payload) {
  return request('/api/recruitmentTask', {
    method: 'POST',
    data: payload,
  });
}

export async function createSatisfaction(body) {
  return request('/api/coursematch/satisfaction', {
    method: 'POST',
    data: body,
  });
}

export async function updateSatisfaction(id, body) {
  return request(`/api/coursematch/satisfaction/${id}`, {
    method: 'PUT',
    data: body,
  });
}
